<div>
  <mat-toolbar class="toolbar">
    <p class="toolbar-text">Batch Key: {{module.batchkey}}</p>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close class="margin-auto">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <div class="content">
    <div class="content-wrapper">
      <div class="module-data">
        <div class="csh-text">
          <div class="headerText">Modules</div>
        </div>
        <div class="options">
          <ul>
            <li style="display: block;" *ngFor="let data of module.module; let i=index" class="textFormat"
              (click)="showTask(data)" [ngClass]="{'bold-font' : selectedModule ==data.application}">
              {{data.application}}
            </li>
          </ul>
        </div>
      </div>
      <div class="task-data">
        <div class="csh-text">
          <div class="headerText">Module > Tasks</div>
        </div>

        <div class="options">
          <ul>
            <li style="display: block;" *ngFor="let data of tasks; let i=index" class="textFormat">
              {{data}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="button-row">
      <button mat-flat-button class="white-button cancelButton" (click)="onClose()"> Close</button>
    </div>
  </div>

</div>